import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

let STEPS = /** @type {const} */ ({
  TREATMENT_PLAN_TEMPLATES: 'treatment_plan_templates',
  TREATMENT_PLANS: 'treatment_plans',
  PAYMENT_PLANS: 'payment_plans',
  CONTRACTS: 'contracts',
})

let NEXT_STEP_ACTION = /** @type {const} */ ({
  [STEPS.TREATMENT_PLAN_TEMPLATES]: STEPS.TREATMENT_PLANS,
  [STEPS.TREATMENT_PLANS]: STEPS.PAYMENT_PLANS,
  [STEPS.PAYMENT_PLANS]: STEPS.CONTRACTS,
  [STEPS.CONTRACTS]: STEPS.PAYMENT_PLANS,
})

let BACK_STEP_ACTION = /** @type {const} */ ({
  [STEPS.TREATMENT_PLANS]: STEPS.TREATMENT_PLAN_TEMPLATES,
  [STEPS.PAYMENT_PLANS]: STEPS.TREATMENT_PLANS,
  [STEPS.CONTRACTS]: STEPS.PAYMENT_PLANS,
})

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSubmit({ value, originalValue, args, change }) {
    switch (args.type) {
      case 'view-contracts': {
        change(next => {
          next.selected.treatment_plan_id = args.treatment_plan_id
          next.current_step =
            NEXT_STEP_ACTION[next.current_step] ?? next.current_step
        })
        break
      }
      case 'continue': {
        change(next => {
          next.current_step =
            NEXT_STEP_ACTION[next.current_step] ?? next.current_step
        })
        break
      }
      case 'back': {
        change(next => {
          next.current_step =
            BACK_STEP_ACTION[next.current_step] ?? next.current_step
        })
        break
      }
      case 'cancel': {
        // reset tx plans selection
        change(next => {
          next.completed = false
          next.current_step = STEPS.TREATMENT_PLAN_TEMPLATES
        })
        setFlowTo(normalizePath(props.viewPath, '../../../TreatmentCard'))
        break
      }
      case 'done': {
        setFlowTo(normalizePath(props.viewPath, '../../../TreatmentCard'))
        break
      }
      default: {
        break
      }
    }
  }
}
